<h1 mat-dialog-title>Download Product File</h1>
<div mat-dialog-content>
  Your file is ready to download.
  <a (click)="onClickDownload()" target="_blank">Download File</a>
</div>
